import React from 'react';
import HarbourStageStrip from './HarbourStageStrip';
import './harbour.css';

/*
 * Harbour/Referral block (1526:9701): one referral (ADHD or autism) inside a
 * record flyout. One grey box holds, in order: the referral name, the stage
 * strip, the fact lines (nominated parent or carer, the service's receipt
 * line, the date line) and, once the letter is out, the letter row. Stack one
 * per referral for a pupil referred for both (4223:305958 on the SENCO
 * record, 3434:8437 on the parent or carer's record).
 *
 * `status` is a chip shown beside the name, for the one thing the strip
 * cannot show (the referral has stopped); otherwise the strip's current
 * stage is the status and nothing repeats it. `letter` is
 * { label, actions } with the actions already built by the caller, because
 * the two audiences have different buttons.
 */
export default function HarbourReferralBlock({ name, stageKey, status = null, facts = [], letter = null }) {
  const lines = facts.filter(Boolean);
  return (
    <div className="harbour-referral-block" role="group" aria-label={name}>
      <div className="harbour-referral-block__head">
        <h3 className="harbour-referral-block__name">{name}</h3>
        {status}
      </div>
      <HarbourStageStrip pathway="referral" currentKey={stageKey} />
      {lines.length > 0 && (
        <div className="harbour-referral-block__facts">
          {lines.map((line) => <p key={line}>{line}</p>)}
        </div>
      )}
      {letter && (
        <div className="harbour-referral-block__letter">
          <span className="harbour-referral-block__letter-label">{letter.label}</span>
          <span className="harbour-referral-block__letter-actions">{letter.actions}</span>
        </div>
      )}
    </div>
  );
}
